import React from 'react';
import { useTranslation } from 'react-i18next';
import { Circle } from 'lucide-react';

export const TasksTableEmpty: React.FC = () => {
  const { t } = useTranslation('goals');

  return (
    <div className="px-4 py-8 text-center">
      <Circle className="h-8 w-8 text-gray-300 mx-auto mb-2" />
      <p className="text-sm text-gray-500">{t('tasksTable.noTasksYet')}</p>
    </div>
  );
};
